import styled from 'styled-components';


export const LogoSvgTitle = styled.label `
color: #DC1D13;
font-weight: 600;
font-size: 28px;
display:flex;
font-family: 'Roboto', sans-serif;
align-items: center;
    justify-content: center;

                                                

`